__turbopack_context__.v({
  "loader-container": "styles-module-scss-module__3H0TVW__loader-container",
  "spin": "styles-module-scss-module__3H0TVW__spin",
});
